import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { LoginService } from 'app/login/services/login.service';
import { LocalizationService } from 'app/shared/localization/localization.service';
import { ResolutionType } from 'app/shared/model/enums';
import { CommonService } from 'app/shared/services/common.service';
import { AppResolutionType } from 'app/shared/common/appResolution';
@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
  AppResolutionType = AppResolutionType;
  ResolutionType = ResolutionType;
  showAccountSettings=true
  constructor(private localizationService: LocalizationService, private loginService: LoginService,private commonService: CommonService) { }

  ngOnInit(): void {
    this.commonService.changeCurrentPageHeader(this.localizationService.Translate('PROFILE.TITLE')) ;
  }
  ngOnDestroy() {
    this.commonService.clearCurrentPageHeader();
  }
}
